export default __webpack_public_path__ + "static/media/placeholder_portfolio04-en-mobile.93f3ed52.png";